/**
 * Redis Cache Key Types
 *
 * Central definition of all supported cache key types.
 * Used across backend (domain) and API schemas.
 */

export const REDIS_KEY_TYPES = ["string", "json", "hash", "list", "set", "zset", "none"] as const;

export type RedisKeyType = (typeof REDIS_KEY_TYPES)[number];

// Named constants for type checks (avoid hardcoded strings)
export const RedisKeyTypes = {
  STRING: "string",
  JSON: "json",
  HASH: "hash",
  LIST: "list",
  SET: "set",
  ZSET: "zset",
  NONE: "none"
} as const satisfies Record<string, RedisKeyType>;
